const title = 'DID Passkey'


const config = {title}

export default config